module.exports = __webpack_public_path__ + "static/img/20.aee59b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/sp/20.png
// module id = HYoK
// module chunks = 0